import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { createLogger } from 'redux-logger';

import { Jumbotron, Navbar, Nav, NavItem } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { Route, Switch } from 'react-router';
import { ConnectedRouter } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';

import store from './store';
import thunk from 'redux-thunk';

import Header from './components/Header';
import Bottom from './components/Bottom';
import ErrorShow from './components/ErrorShow';
import ErrorInput from './components/ErrorInput';
import Tags from './components/TagsShow';
import ErrorsList from './components/ErrorsList';
import ErrorEdit from './components/ErrorEdit';
import UserForm from './components/UserForm';
/*import Slick from './components/Slick';*/
import Home from './components/Home';
import Pay from './components/Pay';
import Info from './components/Info';

import './App.css';

const middle = [ thunk ];

const history = createHistory();

if (process.env.NODE_ENV !== 'production') {
  middle.push(createLogger())
}

class App extends Component {

  render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <div className="App container">
            <Jumbotron className="specialjum">
              <Header/>
            </Jumbotron>
            <div>
              <Info />
            </div>
            <Navbar>
              <Nav>
                <NavItem componentClass={Link} href="/" to="/">首页</NavItem>
                <NavItem componentClass={Link} href="/tags" to="/tags">知识点云</NavItem>
                <NavItem componentClass={Link} href="/errors" to="/errors">错题列表</NavItem>
                <NavItem componentClass={Link} href="/input" to="/input">错题输入</NavItem>
              </Nav>
            </Navbar>
            <Switch>
              <Route path="/" exact component={Home}/>
              <Route path="/user_login" exact component={UserForm}/>
              <Route path="/user_register" exact component={UserForm}/>
              <Route path="/tags" exact component={Tags}/>
              <Route path="/errors" exact component={ErrorsList}/>
              <Route path="/errors/:filter" exact component={ErrorsList}/>
              <Route path="/error/:id" exact component={ErrorShow}/>
              <Route path="/input" exact component={ErrorInput}/>
              <Route path="/erroredit/:id" exact component={ErrorEdit}/>
              <Route path="/pay" exact component={Pay} />
            </Switch>
            <Bottom />
          </div>
        </ConnectedRouter>
      </Provider>
    );
  }
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js